import Vue from 'vue';
import Vuex from 'vuex';
import App from '@/locationsListing/App.vue';
// import Router from '@/locationsListing/router';
import store from '@/locationsListing/store/index';

/**************
 * Example PUG Markup *
#locationsListing
script(src='/vue/locationsListing.js')
link(rel='stylesheet' href='/vue/locationsListing.css')
**************/

window.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('#locationsListing');
  Vue.config.devtools = true;
	Vue.config.productionTip = false;
	
  Vue.use(Vuex);
	
	console.log("store:", store)
	
  new Vue({
    store: new Vuex.Store(store),
		data: () => Object.assign({}, el.dataset),
    render: h => h(App),
  }).$mount(el);
});